import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { isXcxWeb } from '@ivy/fts/utils';
import { env } from '@ivy/fts/envInfo/envInfo';
let MyLogistics = class MyLogistics extends Vue {
    constructor() {
        super(...arguments);
        this.isXcxWeb = isXcxWeb();
        this.data = {};
        this.trajectory = {};
        this.lineList = [];
        this.show = false;
        this.tid = '';
        this.expNum = '';
        this.curExpress = {};
        this.iconMap = {
            [-1]: 'wait',
            0: 'shipped',
            1: 'transit',
            2: 'sending',
            3: 'already',
            4: 'sending-rror',
            5: 'problem',
            6: 'return',
        };
    }
    get iconSrc() {
        return s => {
            return this.iconMap[s]
                ? require(`@/assets/order/${this.iconMap[s]}.png`)
                : '';
        };
    }
    get nextText() {
        let curExpress = (this.curExpress || {});
        let str = '';
        let time;
        switch (this.data.delivery_status) {
            case -1:
                time = curExpress.time
                    ? new Date(curExpress.time).format('YYYY-MM-DD')
                    : '';
                str = `商品已下单，等待发货，预计【${time}】处理发货`;
                break;
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                str = curExpress.status;
                break;
            default:
                str = curExpress.status;
                break;
        }
        return this.getFormatCon(str);
    }
    async created() {
        this.$title('订单跟踪');
        await env.init();
        let isLogin = await env.getIsLogin();
        if (!isLogin) {
            return await env.login();
        }
        this.tid = this.$route.query.tid;
        this.expNum = this.$route.query.expressNum;
        this.getData();
    }
    async getData() {
        const conf = {
            disableAlert: true,
        };
        let { data } = await this.$axios.get(`/api/goods/shop/search/delivery/queryExpress`, {
            params: {
                tid: this.tid,
                expressNum: this.expNum,
            },
            ...conf,
        });
        this.data = data;
        this.trajectory = data.trajectory || {};
        this.lineList = this.trajectory.list || [];
        this.curExpress = this.lineList[0] || {};
        this.show = true;
    }
    changeItem(item) {
        this.show = !this.show;
        setTimeout(() => {
            this.show = !this.show;
            this.curExpress = item || {};
        }, 0);
    }
    getFormatCon(str = '') {
        if (typeof str !== 'string') {
            return str;
        }
        str = str.replace(/(1[0-9]{10})/gi, `<a href="tel:$1" class="tel-text-line">$1</a>`);
        str = str.replace(/([0-9]{3,4}-[0-9]{7,8})/gi, `<a href="tel:$1" class="tel-text-line">$1</a>`);
        return str;
    }
    copy(code) {
        let oInput = document.createElement('input');
        oInput.value = code;
        oInput.style.position = 'absolute';
        oInput.style.top = '-999px';
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand('copy');
        oInput.remove();
        this.$Toast('复制成功 ');
    }
};
MyLogistics = tslib_1.__decorate([
    Component({
        components: {
            CustomerButton: () => import('@ivy/fts/comps/Customer'),
        },
    })
], MyLogistics);
export default MyLogistics;
